/**
 * Valuation Header Component
 * Displays page title, description, and important disclaimer
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Calculator, AlertCircle } from 'lucide-react';

const ValuationHeader = () => {
  return (
    <>
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 flex items-center gap-3">
          <Calculator className="text-blue-600" size={32} />
          Business Opinion of Value Calculator
        </h1>
        <p className="text-gray-600 mt-2">
          Calculate your business opinion of value using multiple industry-standard methodologies
        </p>
      </div>

      {/* IMPORTANT DISCLAIMER */}
      <div className="mb-6 bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-r-lg">
        <div className="flex items-start gap-3">
          <AlertCircle className="text-yellow-600 mt-0.5 flex-shrink-0" size={20} />
          <div>
            <h3 className="font-semibold text-yellow-900 mb-1">Important Disclaimer</h3>
            <p className="text-sm text-yellow-800 leading-relaxed">
              This valuation calculator provides a <strong>simple opinion of value</strong> for exit planning purposes only.
              It is <strong>NOT a formal business valuation</strong> and should not be used for tax, legal, or transactional purposes.
              For official valuations required by the IRS, courts, or financial institutions, please consult a
              Certified Valuation Analyst (CVA), Accredited Senior Appraiser (ASA), or Certified Business Appraiser (CBA).
              This tool is designed to help business owners understand their company's approximate worth and
              guide their exit planning strategy.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

ValuationHeader.propTypes = {};

export default ValuationHeader;
